import { defineStore } from "pinia";
import { ref } from "vue";
import { Configuration, MessageTemplatesApi } from "@/api/javaapi";
import { type GuestLetterTemplate } from "@/api/javaapi/models";
import { useAuthStore } from "@/stores/auth.store";

export const useMessageTemplatesStore = defineStore("messageTemplates", () => {
  const templates = ref<GuestLetterTemplate[]>([]);
  const hasFetched = ref(false);

  function getApiInstance(): MessageTemplatesApi {
    const authStore = useAuthStore();
    if (!authStore.token) {
      throw new Error("No authentication token available");
    }
    return new MessageTemplatesApi(
      new Configuration({ accessToken: authStore.token })
    );
  }

  async function fetchTemplates(force = false): Promise<void> {
    if (!force && hasFetched.value) {
      return;
    }
    try {
      const api = getApiInstance();
      const response = await api.getMessageTemplates();
      if (Array.isArray(response.data)) {
        templates.value = response.data as GuestLetterTemplate[];
      } else {
        throw new Error("Expected an array of templates");
      }
      hasFetched.value = true;
    } catch (error) {
      console.error("Failed to fetch guest letter templates:", error);
      templates.value = [];
      throw error;
    }
  }

  async function getProcessedTemplate(
    templateId: number,
    reservationId: number
  ): Promise<GuestLetterTemplate> {
    try {
      const api = getApiInstance();
      const response = await api.processTemplateReplacements(
        templateId,
        reservationId
      );
      return response.data as GuestLetterTemplate;
    } catch (error) {
      console.error("Failed to get processed template:", error);
      throw error;
    }
  }

  return {
    templates,
    fetchTemplates,
    getProcessedTemplate,
  };
});